'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { setupStyledComponents } from '../listeners/setupStyledComponents';
import ComponentWithBodyClass from '../utils/ComponentWithBodyClass';
export default function UIApplication(props) {
  const {
    _bodyElement,
    bodyClassName,
    name,
    children
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["_bodyElement", "bodyClassName", "name", "children"]);

  useEffect(setupStyledComponents, []);
  return /*#__PURE__*/_jsx(ComponentWithBodyClass, {
    bodyClassName: classNames('ui-app', bodyClassName),
    bodyElement: _bodyElement,
    children: /*#__PURE__*/_jsx("div", Object.assign({
      "data-application-name": name
    }, rest, {
      children: children
    }))
  });
}
UIApplication.propTypes = {
  _bodyElement: PropTypes.object,
  bodyClassName: PropTypes.string,
  name: PropTypes.string.isRequired,
  children: PropTypes.node
};
UIApplication.displayName = 'UIApplication';